global.$ = global.jQuery = require('jquery');

import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import AOS from 'aos';
import 'aos/dist/aos.css';

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
window.Swiper = Swiper;

import Headroom from "headroom.js";

$(document).ready(function() {

    // headroom
    if($('.headroom').length > 0){
        let options = {
            offset: {
                up: 100,
                down: 100
            },
        }
        let headroomEl = document.querySelector("header");
        let headroom  = new Headroom(headroomEl,options);
        headroom.init();
    }

    // To-top button
    //const toTopBtn = $('#to-top');
    // toTopBtn.on('click', function (e) {
    //     e.preventDefault();
    //     $('html, body').animate({
    //         scrollTop: 1000,
    //     }, 'slow');
    // });

    //show button to form
    var buttonToPrenota = $('.buttonToPrenota');
    if (window.innerWidth < 768){
        $(window).scroll(function(){
            if ($(window).scrollTop() > 3000 && $(window).scrollTop() < 8600) {
                buttonToPrenota.addClass("buttonToPrenota--active");
            } else {
                buttonToPrenota.removeClass("buttonToPrenota--active");
            }
        });
    } else {
        $(window).scroll(function(){
            if ($(window).scrollTop() > 500 && $(window).scrollTop() < 3300) {
                buttonToPrenota.addClass("buttonToPrenota--active");
            } else {
                buttonToPrenota.removeClass("buttonToPrenota--active");
            }
        });
    }


    // Burgermenu
    const body = $('body');
    const mobileMenuWrapper = $('.mobileMenuWrapper');
    const burgerMenu = $('.burgermenu');
    burgerMenu.click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (!$(this).hasClass('burgermenu--open')) {
            openCloseMenu()
        } else {
            openCloseMenu(false)
        }
    });

    function openCloseMenu(open = true) {
        if (open) {
            mobileMenuWrapper.stop().fadeIn(300);
            burgerMenu.addClass('burgermenu--open');
            body.addClass('no-scroll-y');
        } else {
            burgerMenu.removeClass('burgermenu--open');
            mobileMenuWrapper.stop().fadeOut(300);
            body.removeClass('no-scroll-y');
        }
    }

    $('.mobileMenuWrapper li a').click(function (e) {
        openCloseMenu(false)
    })

    // AOS animations
    $(function() {
        AOS.init({
            duration: 600,
            //offset: 50,
            once: true,
        });
    });

    let headerITem = $('.header__item-has-submenu');

    if ($(window).innerWidth() >= 758){
        headerITem.on({
            mouseenter: function () {
                if (!headerITem.hasClass('opened')){
                    $(this).addClass('opened');
                    $(this).children('.header__nav-submenu-wrapper').stop().slideDown('fast');
                }
            },
            mouseleave: function () {
                if (headerITem.hasClass('opened')){
                    $(this).removeClass('opened');
                    $(this).children('.header__nav-submenu-wrapper').stop().slideUp('fast');
                }
            }
        });
    } else {
        headerITem.on('click', function(){
            if (!$(this).hasClass('opened')){
                $(this).addClass('opened');
                $(this).children('.header__nav-submenu-wrapper').stop().slideDown('fast');
            } else{
                $(this).removeClass('opened');
                $(this).children('.header__nav-submenu-wrapper').stop().slideUp('fast');
            }
        });
    }

});

// MODIFICA

// Init Context
let c = document.createElement('canvas').getContext('2d')
let postctx = document.getElementById('contcanvas').appendChild(document.createElement('canvas')).getContext('2d')
let canvas = c.canvas
let vertices = []

// Effect Properties
let vertexCount = 7000
let vertexSize = 3
let oceanWidth = 204
let oceanHeight = -80
let gridSize = 32;
let waveSize = 16;
let perspective = 100;

// Common variables
let depth = (vertexCount / oceanWidth * gridSize)
let frame = 0
let { sin, cos, tan, PI } = Math

// Render loop
let oldTimeStamp = performance.now();
let loop = (timeStamp) => {
    let rad = sin(frame / 100) * PI / 20
    let rad2 = sin(frame / 50) * PI / 10
    const dt = (timeStamp - oldTimeStamp) / 1000;
    oldTimeStamp = timeStamp;

    frame += dt * 50;
    if (postctx.canvas.width !== postctx.canvas.offsetWidth || postctx.canvas.height !== postctx.canvas.offsetHeight) {
        postctx.canvas.width = canvas.width = postctx.canvas.offsetWidth
        postctx.canvas.height = canvas.height = postctx.canvas.offsetHeight
    }


    c.fillStyle = `hsl(200deg, 100%, 2%)`
    c.fillRect(0, 0, canvas.width, canvas.height)
    c.save()
    c.translate(canvas.width / 2, canvas.height / 2)

    c.beginPath()
    vertices.forEach((vertex, i) => {
        let ni = i + oceanWidth
        let x = vertex[0] - frame % (gridSize * 2)
        let z = vertex[2] - frame * 2 % gridSize + (i % 2 === 0 ? gridSize / 2 : 0)
        let wave = (cos(frame / 45 + x / 50) - sin(frame / 20 + z / 50) + sin(frame / 30 + z*x / 10000))
        let y = vertex[1] + wave * waveSize
        let a = Math.max(0, 1 - (Math.sqrt(x ** 2 + z ** 2)) / depth)
        let tx, ty, tz

        y -= oceanHeight

        // Transformation variables
        tx = x
        ty = y
        tz = z

        // Rotation Y
        tx = x * cos(rad) + z * sin(rad)
        tz = -x * sin(rad) + z * cos(rad)

        x = tx
        y = ty
        z = tz

        // Rotation Z
        tx = x * cos(rad) - y * sin(rad)
        ty = x * sin(rad) + y * cos(rad)

        x = tx;
        y = ty;
        z = tz;

        // Rotation X

        ty = y * cos(rad2) - z * sin(rad2)
        tz = y * sin(rad2) + z * cos(rad2)

        x = tx;
        y = ty;
        z = tz;

        x /= z / perspective
        y /= z / perspective



        if (a < 0.01) return
        if (z < 0) return


        c.globalAlpha = a
        c.fillStyle = `hsl(${180 + wave * 20}deg, 100%, 50%)`
        c.fillRect(x - a * vertexSize / 2, y - a * vertexSize / 2, a * vertexSize, a * vertexSize)
        c.globalAlpha = 1
    })
    c.restore()

    // Post-processing
    postctx.drawImage(canvas, 0, 0)

    postctx.globalCompositeOperation = "screen"
    postctx.filter = 'blur(16px)'
    postctx.drawImage(canvas, 0, 0)
    postctx.filter = 'blur(0)'
    postctx.globalCompositeOperation = "source-over"

    requestAnimationFrame(loop)
}

// Generating dots
for (let i = 0; i < vertexCount; i++) {
    let x = i % oceanWidth
    let y = 0
    let z = i / oceanWidth >> 0
    let offset = oceanWidth / 2
    vertices.push([(-offset + x) * gridSize, y * gridSize, z * gridSize])
}

loop(performance.now())

// EQUALIZE

;(function($) {

    $.fn.equalize = function(options) {
        var $containers = this, // this is the jQuery object
            children    = false,
            reset       = false,
            equalize,
            type;

        // when options are an object
        if ($.isPlainObject(options)) {
            equalize = options.equalize || 'height';
            children = options.children || false;
            reset    = options.reset || false;
        } else { // otherwise, a string was passed in or default to height
            equalize = options || 'height';
        }

        if (!$.isFunction($.fn[equalize])) { return false; }

        // determine if the height or width is being equalized
        type = (equalize.indexOf('eight') > 0) ? 'height' : 'width';

        return $containers.each(function() {
            // when children exist, equalize the passed in child elements, otherwise equalize the children
            var $children = (children) ? $(this).find(children) : $(this).children(),
                max = 0; // reset for each container

            $children.each(function() {
                var $element = $(this),
                    value;
                if (reset) { $element.css(type, ''); } // remove existing height/width dimension
                value = $element[equalize]();          // call height(), outerHeight(), etc.
                if (value > max) { max = value; }      // update max
            });

            $children.css(type, max +'px'); // add CSS to children
        });
    };

}(jQuery));
